import React from 'react';
//import { useNavigate } from "react-router-dom";

import {
 formatError,
 login,
 runLogoutTimer,
 signUp,
} from '../../services/AuthService';

import { mapUiRole } from "../../utils/mapUiRole";
import { getPermissionNames } from "../../utils/permissions";
import { invalidateMenus } from "../../jsx/layouts/nav/Menu";
import { toast } from 'react-toastify';
export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';


export function saveTokenInLocalStorage(data) {
 // data.token and data.user are typical responses from your backend
 if (data?.token) {
 localStorage.setItem('token', data.token);
 }

 const userObj = data?.user ? { ...data.user } : {};
 // store token inside userDetails too, so older/future code that expects it will work
 if (data?.token) {
 userObj.token = data.token;
 }
 localStorage.setItem('userDetails', JSON.stringify(userObj));

 if (data?.expiresIn) {
 const expiryTime = new Date().getTime() + data.expiresIn * 1000;
 localStorage.setItem('tokenExpiry', expiryTime.toString());
 }
}



// [OK] Signup Action
export function signupAction(name, email, mobile, password, navigate) {
 return (dispatch) => {
 signUp(name, email, mobile, password)
 .then((response) => {
 saveTokenInLocalStorage(response.data);
 runLogoutTimer(dispatch, response.data.expiresIn * 1000, navigate);
 dispatch(confirmedSignupAction(response.data));
 navigate('/dashboard');
 })
 .catch((error) => {
 const errorMessage = formatError(error.response?.data);
 dispatch(signupFailedAction(errorMessage));
 });
 };
}


export const Logout = (navigate) => (dispatch) => {
 localStorage.removeItem('userDetails');
 localStorage.removeItem('token');
 localStorage.removeItem('tokenExpiry');
 invalidateMenus();

 dispatch({ type: LOGOUT_ACTION });

 if (navigate && typeof navigate === 'function') {
 navigate('/');
 }
};


export function loginAction(email, password, navigate) {
 return (dispatch) => {
 login(email, password)
 .then((response) => {
 const { user, token } = response.data;

 // ADD THIS
 const uiRole = mapUiRole(user.role);

 const enhancedUser = {
 ...user,
 uiRole,
 permissionNames: getPermissionNames(user),
 };

 saveTokenInLocalStorage({
 token,
 user: enhancedUser,
 });

 dispatch(loginConfirmedAction({
 token,
 user: enhancedUser,
 }));

 toast.success("Login successful!", { autoClose: 1500 });
 navigate("/dashboard");
 })
 .catch((error) => {
 const errorMessage = formatError(error.response?.data || error.message);
 dispatch(loginFailedAction(errorMessage));
 });
 };
}

// [OK] Action Creators
export function loginFailedAction(data) {
 return {
 type: LOGIN_FAILED_ACTION,
 payload: data,
 };
}

export function loginConfirmedAction(data) {
 return {
 type: LOGIN_CONFIRMED_ACTION,
 payload: data,
 };
}

export function confirmedSignupAction(payload) {
 return {
 type: SIGNUP_CONFIRMED_ACTION,
 payload,
 };
}

export function signupFailedAction(message) {
 return {
 type: SIGNUP_FAILED_ACTION,
 payload: message,
 };
}

export function loadingToggleAction(status) {
 return {
 type: LOADING_TOGGLE_ACTION,
 payload: status,
 };
}
